var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alert alert-success" }, [
    _c("img", { attrs: { src: "/static/images/verified.png" } }),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("p", [_vm._v(_vm._s(_vm.$t("title")))]),
      _vm._v(" "),
      _c("p", { staticClass: "small" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.$t("message", { company: _vm.companyName, epc: _vm.gs1Id })
            ) +
            "\n    "
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-207952b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-207952b7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alerts/Gs1AlertVerified.vue
// module id = null
// module chunks = 